import React from "react";
import qapi from "views_shared/app/javascript/api";
import EntityPicker from "../../entity_picker/EntityPicker";

function ExpertPicker({ onExpertPicked, onKeyDown, expertsIdsToExclude, selectRef }) {
  return (
    <EntityPicker
      resource={qapi.experts}
      select={["id", "name", "profile_image_url", "featured_title_at_company"]}
      toOption={(expert) => ({
        label: expert.name,
        value: expert.id,
        imageUrl: expert.profile_image_url,
        subtitle: expert.featured_title_at_company,
      })}
      idsToExclude={expertsIdsToExclude}
      onPicked={onExpertPicked}
      onKeyDown={onKeyDown}
      selectRef={selectRef}
    />
  );
}

export default ExpertPicker;
